var _path, _path2, _path3, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoactive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.3498 6.17793L15.901 10.6268C15.6356 10.8921 15.2976 11.073 14.9296 11.1466L12.8659 11.5594L13.2787 9.49569C13.3523 9.12767 13.5332 8.78968 13.7985 8.5243L18.2473 4.07546M20.3498 6.17793L21.4758 5.05193C21.847 4.68073 21.847 4.0789 21.4758 3.7077L20.7175 2.94946C20.3463 2.57826 19.7445 2.57826 19.3733 2.94946L18.2473 4.07546M20.3498 6.17793L18.2473 4.07546",
    stroke: "#623CE7",
    strokeWidth: 1.90103,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.882 12.4703C19.882 14.0954 19.4392 16.5334 18.481 17.8847C17.5229 19.236 16.2535 20.3478 14.6601 20.9697C13.0667 21.5916 11.1615 21.9163 9.46998 21.5992C7.77845 21.2822 6.14176 20.2187 4.92223 19.0696C3.70271 17.9204 2.8722 16.4563 2.53574 14.8624C2.19927 13.2685 2.34623 11.0756 3.00623 9.57419C3.66623 8.07275 5.0429 6.51064 6.47691 5.60776C7.91092 4.70488 10.0377 4.41118 11.7624 4.41118",
    stroke: "#623CE7",
    strokeWidth: 1.90103,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1426 13.4902L10.1426 17.5342",
    stroke: "#623CE7",
    strokeWidth: 1.90103,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10.142,
    cy: 10.9111,
    r: 0.979438,
    fill: "#623CE7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoactive);
export default __webpack_public_path__ + "static/media/infoactive.8b2c16b63a8a7ff8c9be7bd4e4215bee.svg";
export { ForwardRef as ReactComponent };